import React from "react";
import { LegType } from "../types";
import { LegIcon } from "./LegIcon";
import { LegText } from "./LegText";

export const Leg = ({
  icon,
  children,
  bulletType = "hollow",
  boldText = false,
  isTitle = false,
  isEventDetails = false,
  text = "",
  characterLimit,
  options = {},
  isFirstLeg = false,
  isLastLeg = false,
  eventDetails,
  isSingleLeg,
  hasEventDetails,
  description,
  legTestId
}: LegType) => {
  const {
    hideBottomPole = false,
    hideBullet = false,
    showBulletOnly = false,
  } = options;
  
  if (!text && !children && !showBulletOnly && !isEventDetails) return null;
  return (
    <>
      <LegIcon
        {...{
          hideBottomPole,
          isLastLeg,
          isFirstLeg,
          hideBullet,
          icon,
          text,
          bulletType,
          isSingleLeg
        }}
      />
      <LegText
        {...{
          isTitle,
          isEventDetails,
          boldText,
          hideBullet,
          showBulletOnly,
          text,
          characterLimit,
          eventDetails,
          children,
          isFirstLeg,
          isSingleLeg,
          description,
          hasEventDetails,
          legTestId
        }}
      />
    </>
  );
};
